import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import {
  Box,
  Text,
  Title,
  Button,
  Container,
  createStyles,
} from "@mantine/core";

import { Logo } from "@components/Logo/Logo";
import { LanguageSelector } from "@components/LanguageSelector/LanguageSelector";

const useStyles = createStyles((t) => ({
  wrapper: {
    flex: 1,
    width: "100%",
    paddingBlock: 90,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  content: {
    maxWidth: 800,
    display: "flex",
    gap: t.spacing.lg,
    textAlign: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

export const Thankyou: FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Container className={classes.wrapper}>
      <Logo />
      <Box className={classes.content}>
        <Title>{t("thankyou.title")}</Title>
        <Text size="lg" maw={610}>
          {t("thankyou.description")}
        </Text>
        <Text color="dimmed" size="sm" maw={500}>
          {t("thankyou.p1")}
        </Text>
        <Text color="dimmed" size="sm" maw={500}>
          <Trans
            i18nKey={"thankyou.p2"}
            // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
            components={{ linkTag: <a /> }}
          ></Trans>
          <br />
          {t("thankyou.thankyou")}
          <br />
          {t("thankyou.from")}
        </Text>
        <Button onClick={() => navigate("/portal")}>
          {t("Back to portal")}
        </Button>
      </Box>
      <LanguageSelector />
    </Container>
  );
};
